import { registerPlugin } from '@capacitor/core';
const AppReview = registerPlugin('AppReview', {
    web: () => import('./web').then((m) => new m.AppReviewWeb())
});
export * from './definitions';
export { AppReview };
//# sourceMappingURL=index.js.map